module.exports = __webpack_public_path__ + "img/cloud-drizzle-moon.b8f55ed0.svg";